import { Link } from 'react-router-dom';

function EmptyGardenBedIllustration() {
  return (
    <svg
      viewBox="0 0 760 520"
      role="img"
      aria-labelledby="empty-garden-title empty-garden-description"
      className="h-auto w-full"
    >
      <title id="empty-garden-title">An empty garden bed with a coming soon sign</title>
      <desc id="empty-garden-description">
        A winding path leads past an empty raised garden bed, a coming soon sign, a confused bee, and a small tomato seedling holding a map.
      </desc>
      <rect width="760" height="520" fill="#fbf8ef" />
      <path
        d="M34 468 C164 424 202 368 282 342 C360 316 442 344 536 292 C620 244 642 162 725 112"
        fill="none"
        stroke="#d8d0be"
        strokeWidth="54"
        strokeLinecap="round"
      />
      <path
        d="M34 468 C164 424 202 368 282 342 C360 316 442 344 536 292 C620 244 642 162 725 112"
        fill="none"
        stroke="#f4efe3"
        strokeWidth="38"
        strokeLinecap="round"
      />
      <g transform="translate(98 286)">
        <path d="M44 42 L420 4 L508 120 L116 168 Z" fill="#8e6a48" />
        <path d="M116 168 L508 120 L508 176 L118 224 Z" fill="#5c422d" />
        <path d="M44 42 L116 168 L118 224 L42 92 Z" fill="#6f5035" />
        <path d="M86 52 L407 22 L466 102 L132 140 Z" fill="#3b2b20" />
        <g stroke="#5d3e29" strokeLinecap="round" strokeWidth="4">
          <path d="M136 82 C188 64 246 104 304 82 C346 66 388 72 432 90" />
          <path d="M112 106 C170 84 222 124 280 104 C338 84 392 98 456 112" />
        </g>
      </g>
      <g transform="translate(486 166)">
        <path d="M42 210 L54 78" stroke="#5b3d28" strokeWidth="8" strokeLinecap="round" />
        <path d="M3 52 L160 36 L170 100 L14 116 Z" fill="#fffdf7" stroke="#5b3d28" strokeWidth="4" />
        <text x="86" y="76" textAnchor="middle" fill="#10351f" fontFamily="Georgia, serif" fontSize="28">
          Coming
        </text>
        <text x="88" y="102" textAnchor="middle" fill="#8e3a2b" fontFamily="Georgia, serif" fontSize="24">
          Soon
        </text>
      </g>
      <g transform="translate(438 350)">
        <path d="M45 105 C42 72 50 42 70 16" fill="none" stroke="#32633d" strokeWidth="8" strokeLinecap="round" />
        <path d="M52 54 C24 38 15 18 22 2 C48 9 62 28 58 52" fill="#7da263" stroke="#32633d" strokeWidth="3" />
        <path d="M65 48 C92 28 112 28 124 40 C105 62 82 65 65 48" fill="#9ebf78" stroke="#32633d" strokeWidth="3" />
        <circle cx="72" cy="12" r="9" fill="#a43b29" />
        <circle cx="92" cy="10" r="8" fill="#a43b29" />
        <path d="M4 84 L78 70 L122 110 L44 126 Z" fill="#fffdf7" stroke="#43513f" strokeWidth="3" />
        <path d="M36 82 L64 112 M66 74 L93 101" stroke="#cfc7b6" strokeWidth="3" />
        <path d="M24 104 C42 92 52 90 72 98" fill="none" stroke="#8e3a2b" strokeWidth="3" strokeLinecap="round" />
      </g>
      <g transform="translate(104 132)">
        <path d="M32 38 C64 8 110 16 126 48 C95 76 50 72 32 38Z" fill="#f3c94a" stroke="#5b3d28" strokeWidth="4" />
        <path d="M72 18 C70 34 76 54 96 66" fill="none" stroke="#5b3d28" strokeWidth="5" strokeLinecap="round" />
        <path d="M96 18 C90 36 96 52 116 58" fill="none" stroke="#5b3d28" strokeWidth="5" strokeLinecap="round" />
        <ellipse cx="20" cy="38" rx="20" ry="16" fill="#5b3d28" />
        <circle cx="13" cy="33" r="3" fill="#fbf8ef" />
        <path d="M24 22 C16 2 0 0 -12 12" fill="none" stroke="#5b3d28" strokeWidth="3" strokeLinecap="round" />
        <path d="M34 18 C30 -3 46 -8 58 4" fill="none" stroke="#5b3d28" strokeWidth="3" strokeLinecap="round" />
        <path d="M64 34 C92 8 132 0 150 22" fill="none" stroke="#cdd7c3" strokeWidth="16" strokeLinecap="round" opacity="0.65" />
        <path d="M58 50 C90 78 130 84 158 62" fill="none" stroke="#cdd7c3" strokeWidth="16" strokeLinecap="round" opacity="0.65" />
        <path d="M158 44 C186 38 202 48 212 68" fill="none" stroke="#8e9e8e" strokeWidth="3" strokeLinecap="round" strokeDasharray="5 8" />
      </g>
      <g fill="none" stroke="#8e9e8e" strokeLinecap="round" strokeWidth="3" opacity="0.8">
        <path d="M88 238 C78 210 80 188 94 162" />
        <path d="M92 196 C70 184 64 166 72 150 C92 156 102 172 96 192" />
        <path d="M650 384 C642 354 650 326 676 296" />
        <path d="M660 346 C690 346 708 330 714 306 C686 300 668 320 660 346" />
      </g>
    </svg>
  );
}

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#f8f4ea] text-[#18271e]">
      <section className="border-b border-[#d8d0be] bg-[#fbf8ef]">
        <div className="mx-auto grid max-w-[92rem] gap-10 px-6 py-12 sm:px-10 md:grid-cols-[minmax(0,0.9fr)_minmax(18rem,0.8fr)] md:items-center md:py-16 lg:px-16">
          <div className="max-w-3xl">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#8e3a2b]">
              404
            </p>
            <h1 className="mt-4 font-serif text-5xl font-normal leading-tight text-[#0c351e] sm:text-6xl lg:text-7xl">
              This plot hasn&apos;t been planted yet 🌱
            </h1>
            <div className="mt-6 h-px w-28 bg-[#304536]" />
            <div className="mt-8 max-w-2xl space-y-5 text-lg leading-8 text-[#445044]">
              <p>Looks like this link wandered off the path.</p>
              <p>
                Maybe a squirrel moved it. Maybe it&apos;s still germinating. Either way,
                there&apos;s nothing growing here yet.
              </p>
              <p>
                But you&apos;re still in the right garden: a place for community, fresh food,
                young Black and BIPOC leadership, and safe spaces to grow together.
              </p>
            </div>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <Link
                to="/"
                className="inline-flex items-center justify-between border border-[#43513f] bg-[#10351f] px-5 py-4 text-base font-medium text-[#fbf8ef] transition-colors hover:bg-[#0a2416] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b] focus:ring-offset-2 focus:ring-offset-[#fbf8ef] sm:min-w-44"
              >
                <span>Go back home</span>
                <span aria-hidden="true">&rarr;</span>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-between border border-[#c9bfae] px-5 py-4 text-base font-medium text-[#10351f] transition-colors hover:border-[#8e3a2b] hover:bg-[#f4efe3] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b] focus:ring-offset-2 focus:ring-offset-[#fbf8ef] sm:min-w-44"
              >
                <span>Volunteer with us</span>
                <span aria-hidden="true">&rarr;</span>
              </Link>
              <Link
                to="/events"
                className="inline-flex items-center justify-between border border-[#c9bfae] px-5 py-4 text-base font-medium text-[#10351f] transition-colors hover:border-[#8e3a2b] hover:bg-[#f4efe3] focus:outline-none focus:ring-2 focus:ring-[#8e3a2b] focus:ring-offset-2 focus:ring-offset-[#fbf8ef] sm:min-w-44"
              >
                <span>See what&apos;s growing</span>
                <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>

          <div className="border border-[#d8d0be] bg-[#fffdf7] p-3 shadow-sm">
            <EmptyGardenBedIllustration />
          </div>
        </div>
      </section>
    </div>
  );
}

export default NotFoundPage;
